import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import CurrencyInput from '../global/CurrencyInput';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import Swal from "sweetalert2";
import UserBankAcountModel from '../../models/UserBankAcountModel';
import { RiNotificationBadgeLine, RiVipCrown2Fill, RiCloseLine, RiSendPlaneFill } from "react-icons/ri";

const validationSchema = Yup.object().shape({
    content: Yup.string().required('Không được để trống!'),
    amount: Yup.string().required('Không được để trống!'),
    fromName: Yup.string().required('Không được để trống!'),
    fromNumber: Yup.string().required('Không được để trống!'),
});

function ModalPushNoti(props) {
    const [initialValues, setInitialValues] = useState({
        user_bank_id: '',
        accountNumber: '',
        accountUsername: '',
        bank_name: '',
        type: '',
        account_balance: '',
        content: '',
        amount: '',
        fromName: '',
        fromNumber: '',
        phone: '',
    });

    useEffect(() => {
        if (props.data) {
            setInitialValues({
                user_bank_id: props.data.id,
                accountNumber: props.data.bank_number,
                accountUsername: props.data.bank_username,
                bank_name: props.data.name,
                type: props.data.type,
                account_balance: props.data.account_balance,
                phone: props.data.phone,
                content: '',
                amount: '',
                fromName: '',
                fromNumber: '',
            });
        }
    }, [props.data]);

    const onSubmit = (values) => {
        UserBankAcountModel.pushNoti(values).then((res) => {
            if (res.success == true) {
                Swal.fire({
                    icon: "success",
                    title: res.data.title,
                    text: res.data.messages,
                    showConfirmButton: true
                });
            } else {
                Swal.fire({
                    icon: "error",
                    title: res.messages,
                    showConfirmButton: false,
                    timer: 2000
                });
            }
        }).catch(() => {
            Swal.fire({
                icon: "error",
                title: "Gửi thông báo thất bại!",
                showConfirmButton: false,
                timer: 2000
            });
        });
    };

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter" className="d-flex align-items-center gap-2">
                    <RiNotificationBadgeLine size={18} style={{ color: 'var(--wus-text)' }} />
                    <span>Tạo Thông Báo Biến Động Số Dư</span>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {props.data && Number(props.data.is_from_combo) === 1 ? (
                    <div className="d-flex align-items-center gap-2 p-3 mb-3" style={{ background: 'var(--wus-warning-bg)', border: '1px solid var(--wus-warning-border)', borderRadius: '10px', color: 'var(--wus-text-secondary)', fontSize: '12.5px' }}>
                        <RiVipCrown2Fill size={20} style={{ color: 'var(--wus-warning-text)' }} className="flex-shrink-0" />
                        <div>
                            <strong style={{ color: 'var(--wus-warning-text)' }}>Đặc quyền Bank VIP Combo:</strong> Miễn phí <strong>100%</strong> Phí Chuyển khoản (0đ) &amp; Miễn phí Push thông báo (0đ).
                        </div>
                    </div>
                ) : (
                    <div className="p-3 mb-3" style={{ background: 'var(--wus-danger-bg)', border: '1px solid var(--wus-danger-border)', borderRadius: '10px', color: 'var(--wus-text-secondary)', fontSize: '12.5px' }}>
                        <div className="mb-1">
                            ⚠️ <strong style={{ color: 'var(--wus-danger-text)' }}>Tài khoản thường (không sử dụng Combo VIP):</strong>
                        </div>
                        <div style={{ paddingLeft: '18px', lineHeight: '1.5' }}>
                            • Chuyển khoản (quét STK) qua App / API: <strong style={{ color: 'var(--wus-text)' }}>400đ / lần</strong><br />
                            • Phí Push thông báo biến động số dư: <strong style={{ color: 'var(--wus-text)' }}>200đ / lần</strong> (trừ vào số dư web)
                        </div>
                    </div>
                )}

                <Formik
                    initialValues={initialValues}
                    enableReinitialize={true}
                    validationSchema={validationSchema}
                    onSubmit={onSubmit}
                >
                    {({ errors, touched, setFieldValue }) => (
                        <Form>
                            {/* Target Account Info Summary */}
                            <div className="wus-info-box mb-3">
                                <div className="row g-2" style={{ fontSize: '12.5px' }}>
                                    <div className="col-sm-4">
                                        <span style={{ color: 'var(--wus-text-subtle)', display: 'block', fontSize: '11px' }}>NGÂN HÀNG THỤ HƯỞNG</span>
                                        <strong style={{ color: 'var(--wus-text)' }}>{initialValues.bank_name || '---'}</strong>
                                    </div>
                                    <div className="col-sm-4">
                                        <span style={{ color: 'var(--wus-text-subtle)', display: 'block', fontSize: '11px' }}>SỐ TÀI KHOẢN NHẬN</span>
                                        <strong style={{ color: 'var(--wus-text)', fontFamily: 'var(--wus-mono)' }}>{initialValues.accountNumber || '---'}</strong>
                                    </div>
                                    <div className="col-sm-4">
                                        <span style={{ color: 'var(--wus-text-subtle)', display: 'block', fontSize: '11px' }}>CHỦ TÀI KHOẢN NHẬN</span>
                                        <strong style={{ color: 'var(--wus-text)' }}>{initialValues.accountUsername || '---'}</strong>
                                    </div>
                                </div>
                            </div>

                            <div className="row g-3 mb-3">
                                <div className="col-md-6">
                                    <label htmlFor="amount" className="form-label">Số tiền cộng (+ VNĐ)</label>
                                    <CurrencyInput
                                        className="form-control font-monospace"
                                        placeholder="Nhập số tiền..."
                                        onChange={e => {
                                            let value = e.target.value || "";
                                            value = value.replaceAll(',', '');
                                            setFieldValue("amount", value);
                                        }}
                                        type="text"
                                        autoFocus
                                    />
                                    {errors.amount && touched.amount && (
                                        <div className="text-danger small mt-1">{errors.amount}</div>
                                    )}
                                </div>
                                <div className="col-md-6">
                                    <label htmlFor="content" className="form-label">Nội dung chuyển khoản</label>
                                    <Field className="form-control" type="text" id="content" name="content" placeholder="VD: NGUYEN VAN A chuyen tien" />
                                    {errors.content && touched.content && (
                                        <div className="text-danger small mt-1">{errors.content}</div>
                                    )}
                                </div>
                                <div className="col-md-6">
                                    <label htmlFor="fromName" className="form-label">Tên người gửi</label>
                                    <Field className="form-control" type="text" id="fromName" name="fromName" placeholder="VD: NGUYEN VAN A" />
                                    {errors.fromName && touched.fromName && (
                                        <div className="text-danger small mt-1">{errors.fromName}</div>
                                    )}
                                </div>
                                <div className="col-md-6">
                                    <label htmlFor="fromNumber" className="form-label">Số tài khoản người gửi</label>
                                    <Field className="form-control font-monospace" type="text" id="fromNumber" name="fromNumber" placeholder="Nhập STK người gửi" />
                                    {errors.fromNumber && touched.fromNumber && (
                                        <div className="text-danger small mt-1">{errors.fromNumber}</div>
                                    )}
                                </div>
                            </div>

                            <div className="modal-footer px-0 pb-0 mt-2">
                                <button type="button" className="btn btn-secondary" onClick={props.onHide}>
                                    <RiCloseLine className="me-1" size={16} />
                                    Đóng
                                </button>
                                <button type="submit" className="btn btn-primary">
                                    <RiSendPlaneFill className="me-1" size={15} />
                                    Gửi thông báo
                                </button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </Modal.Body>
        </Modal>
    );
}

export default ModalPushNoti;